import { useDispatch } from 'react-redux';

import { setDisplayMenu } from 'redux/app/appSlice';

import MenuIcon from 'images/header/menu.svg?react';

import s from './btnMenu.module.css';

function BtnMenu() {
  const dispatch = useDispatch();

  const displayMenu = () => dispatch(setDisplayMenu(true));

  return (
    <button
      type="button"
      onClick={displayMenu}
      className={s.btn_menu}
      title="menu"
    >
      <MenuIcon />
    </button>
  );
}

export default BtnMenu;
